import { lazy } from "react";
import { Route, Navigate } from "react-router-dom";

const AdminLogin = lazy(() => import("./pages/AdminLogin.jsx"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard.jsx"));
const AdminApplications = lazy(() => import("./pages/AdminApplications.jsx"));
const AdminUsers = lazy(() => import("./pages/AdminUsers.jsx"));
const AdminDarkStores = lazy(() => import("./pages/AdminDarkStores.jsx"));
const AdminDarkStoreRequests = lazy(() => import("./pages/AdminDarkStoreRequests.jsx"));
const AdminAreas = lazy(() => import("./pages/AdminAreas.jsx"));
const AdminAuditLog = lazy(() => import("./pages/AdminAuditLog.jsx"));
const AdminTickets = lazy(() => import("./pages/AdminTickets.jsx"));
const AdminNetworkOverview = lazy(() => import("./pages/AdminNetworkOverview.jsx"));
const AdminNetworkStores = lazy(() => import("./pages/AdminNetworkStores.jsx"));
const AdminNetworkRiders = lazy(() => import("./pages/AdminNetworkRiders.jsx"));
const AdminFunnel = lazy(() => import("./pages/AdminFunnel.jsx"));

export default function AdminRoutes() {
  return (
    <>
      <Route path="/admin" element={<AdminLogin />} />
      <Route path="/admin/login" element={<Navigate to="/admin" replace />} />
      <Route path="/admin/dashboard" element={<AdminDashboard />} />
      <Route path="/admin/network" element={<AdminNetworkOverview />} />
      <Route path="/admin/network/stores" element={<AdminNetworkStores />} />
      <Route path="/admin/network/riders" element={<AdminNetworkRiders />} />
      <Route path="/admin/applications" element={<AdminApplications />} />
      <Route path="/admin/users" element={<AdminUsers />} />
      <Route path="/admin/users/list" element={<Navigate to="/admin/users" replace />} />
      <Route path="/admin/dark-stores" element={<AdminDarkStores />} />
      <Route path="/admin/areas" element={<AdminAreas />} />
      <Route path="/admin/dark-store-requests" element={<AdminDarkStoreRequests />} />
      <Route path="/admin/tickets" element={<AdminTickets />} />
      <Route path="/admin/funnel" element={<AdminFunnel />} />
      <Route path="/admin/audit-log" element={<AdminAuditLog />} />
    </>
  );
}
